/**
 * A processor to do nothing
 * @param cellData
 * @param layer
 */
export function nilProcessor(cellData: any, layer: any) {
    return cellData;
}
